<template>
  <div>
    <PrimaryBox :flag="true">
      <template slot="title">视频监控</template>
      <template slot="more">
        <span class="more" @click="showMore">更多></span>
      </template>
      <div style="height: 15vh">
        <div style="float: left;width: 50%;height: 15vh">
          <monitor-windows ref="monitorWin1" :item="monitorPointList[0]"></monitor-windows>
        </div>
        <div style="float: left;width: 50%;height: 15vh">
          <monitor-windows ref="monitorWin2" :item="monitorPointList[1]"></monitor-windows>
        </div>
      </div>
    </PrimaryBox>
    <Modal v-model="moreIsShow" footer-hide :width="70" title="监控列表" transfer style="min-height: 80vh"
           @on-visible-change="visibleChange">
      <div class="top">
        <div style="width: 10%;height:3vh;float: left">
          <Select v-model="currentCounty" @on-change="getMonitorPointAndMunber">
            <Option v-for="(item,index) in countyList" :key="index" :label="item.name" :value="item.indexCode"></Option>
          </Select>
        </div>
        <div style="width: 30%;float: right">
          <Checkbox v-model="isLine">只显示在线</Checkbox>
          <RadioGroup v-model="gridType" @on-change="changeScreen">
            <Radio :label="4"><span>四分屏</span></Radio>
            <Radio :label="9"><span>九分屏</span></Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="content">
        <div class="leftBox">
          <div class="box">
            <div class="isLineBox">
              <p class="value">{{ ((parseInt(iconList[1].num) / parseInt(iconList[0].num)) * 100).toFixed(1) }}<span
                style="font-size: .3rem;">%</span></p>
              <span class="title">在线率</span>
            </div>
            <div class="detail">
              <div v-for="(item,index) in iconList" :key="index">
                <img class="img" :src="item.icon" alt="">
                <p class="num">{{ item.num }}</p>
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div id="playVideo">
            <div v-if="gridType === 4">
              <jessibuca4 ref="jessibuca4" :videolist="videolist" :streamStatusList="streamStatusList"
                          :isFullScreen="isFullScreen" :videonamelist="videonamelist"></jessibuca4>
            </div>
            <div v-if="gridType === 9">
              <jessibuca9 ref="jessibuca9" :videolist="videolist" :streamStatusList="streamStatusList"
                          :isFullScreen="isFullScreen" :videonamelist="videonamelist"></jessibuca9>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;height: 3vh">
        <div style="width: 40%;margin:  0 auto">
          <Page
            :total="dataTotal"
            show-total
            :page-size="pageSize"
            :current-page="currentPage"
            @on-change="pageChange"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import MonitorWindows from "@/views/Screen/components/Map/components/MonitorWindows.vue";
import Shexiangtou from '../../images/icon_shexiangtou.png'
import Shexiangtoulixian from '../../images/icon_shexiangtoulixian.png'
import Shexiangtouzaixian from '../../images/icon_shexiangtouzaixian.png'
import Jessibuca9 from "@/views/stereoscopicInspection/components/flvh265-9.vue";
import Jessibuca4 from "@/views/stereoscopicInspection/components/flvh265-4.vue";

export default {
  components: {
    Jessibuca4,
    Jessibuca9,
    MonitorWindows,
    PrimaryBox
  },
  data() {
    return {
      videolist: [],
      monitorPointList: [],
      videonamelist: [],
      isFullScreen: false,
      streamStatusList: [],
      moreIsShow: false,
      countyList: [],
      currentCounty: null,
      isLine: true,
      gridType: 4,
      currentPage: 1,
      pageSize: 4,
      dataTotal: 0,
      iconList: [{
        icon: Shexiangtou,
        title: '摄像头总数',
        num: 0
      }, {
        icon: Shexiangtouzaixian,
        title: '在线摄像头',
        num: 0
      }, {
        icon: Shexiangtoulixian,
        title: '离线摄像头',
        num: 0
      }]
    }
  },
  mounted() {
    this.getSubordinateCounty();
    this.getVideoSurveillanceData();
  },
  methods: {
    getMonitorPointAndMunber() {
      this.getMonitorPointNumber()
      this.getMonitorPoint()
    },
    changeScreen() {
      this.pageSize = this.gridType
      this.destoryReverseVideo();
      this.getMonitorPoint()
    },
    showMore() {
      this.moreIsShow = true
      this.$nextTick(() => {
        this.getMonitorPointNumber()

      })
    },
    // 获取相关数量
    getMonitorPointNumber() {
      this.$http.get(`/api/point/getMonitorPointNumber?indexCode=${this.currentCounty}`).then(res => {
        if (res.status === 200) {
          this.iconList[0].num = res.data[0].total
          this.iconList[1].num = res.data[0].normal
          this.iconList[2].num = res.data[0].abnormal
        }
      })
    },
    visibleChange(val) {
      if (!val) {
        this.destoryReverseVideo();
      }
    },
    // 获取监控
    getMonitorPoint() {
      let params = {
        unitindexcode: this.currentCounty,
        streamingstatus: this.isLine ? 'normal' : ''
        // pageNum: this.currentPage,
        // pageSize: this.pageSize
      }
      this.$http.post(`/api/point/monitorPoint?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          let videos = this.formatData(res.data.data.list);
          this.videolist = videos[0];
          this.streamStatusList = videos[1];
          this.videonamelist = videos[2];
          this.dataTotal = res.data.data.total
          this.$nextTick(() => {
            this.switchStart()
          })
        }
      })
    },
    // 获取视频监控数据
    getVideoSurveillanceData() {
      this.$http.post("/api/point/monitorPoint?page=1&size=2", {
        streamingstatus: "normal"
      }).then(res => {
        if (res.status === 200) {
          this.monitorPointList = res.data.data.list;
          this.$refs.monitorWin1.playVideo()
          this.$refs.monitorWin2.playVideo()
        }
      });
    },
    // 获取下级区县
    getSubordinateCounty() {
      this.$http.get("/api/getLowerLevelDepts?flag=3").then(res => {
        if (res.status === 200) {
          this.countyList = res.data;
          this.currentCounty = res.data[0].indexCode;
          this.$nextTick(() => {
            this.getMonitorPoint()
            this.getMonitorPointNumber();
          })
        }
      });
    },
    formatData(data) {
      let videolist = [];
      let streamStatusList = [];
      let videonamelist = [];
      let closeOfflinePlay = this.closeOfflinePlay;
      for (const item of data) {
        item['stream_url'] = `${this.$videoUrl}/rtp/${item['deviceId']}_${item['deviceId']}.live.flv`
        if (item['streamingstatus'] == 'normal') {
          streamStatusList.push('online');
          videolist.push(item['stream_url']);
          videonamelist.push(item['name']);
        } else {
          if (!closeOfflinePlay) {
            videolist.push(item['stream_url']);
            streamStatusList.push('offline');
            videonamelist.push(item['name']);
          }
        }
      }
      return [videolist, streamStatusList, videonamelist]
    },
    switchStart() {
      if (this.gridType == '9') {
        this.$refs.jessibuca9.switchStart();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca4.switchStart();
      }
    },
    destoryVideo() {
      if (this.gridType == '9') {
        this.$refs.jessibuca9.batchDestoryVideo();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca4.batchDestoryVideo();
      }
    },
    destoryReverseVideo() {
      if (this.gridType == '9') {
        this.$refs.jessibuca4.batchDestoryVideo();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca9.batchDestoryVideo();
      }
    },
    screenToggle() {
      this.isFullScreen = true;
      this.enterfullscreen();
    },
    enterfullscreen() { //进入全屏
      let docElm = document.getElementById('playVideo')  // 指定容器id
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    exitFullScreen() {
      console.log('in the exit full screen')
    },
    leaveFullScreen() {
      this.isFullScreen = false;
    },
    pageChange(page) {
      this.currentPage = page
      this.getMonitorPoint()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getMonitorPoint()
    },
  }
}
</script>
<style scoped lang="less">
@import "videoModal.less";

.more {
  color: #13C8FC;
  font-size: .6rem !important;
  margin-right: 2rem;
  cursor: pointer;
  z-index: 99999;
}

:deep(.ivu-page-item) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-next) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-prev) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-item-active) {
  background-color: #2E6B9E;
  border: 1px solid #2E6B9E;
}

//:deep(.flvh265div-4) {
//  .containeritem {
//    height: 45%!important;
//  }
//}

:deep(.flvh265div-9) {
  .containeritem {
    //height: 30%!important;
    height: 19.5vh !important;
  }
}
</style>
